// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal.modal--window {
  top: auto;
  left: auto;
  right: auto;
  bottom: auto;
}

.modal--window .modal--fill {
  box-sizing: border-box;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 15px;
  z-index: 100;
}

.modal--window * {
  font-family: "Manrope";
  font-size: 1em;
}

.modal--window .modal--body {
  justify-content: flex-start;
  padding: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ModalWindow.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,4EAA4E;EAC5E,aAAa;EACb,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd","sourcesContent":[".modal.modal--window {\n  top: auto;\n  left: auto;\n  right: auto;\n  bottom: auto;\n}\n\n.modal--window .modal--fill {\n  box-sizing: border-box;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  padding: 15px;\n  z-index: 100;\n}\n\n.modal--window * {\n  font-family: \"Manrope\";\n  font-size: 1em;\n}\n\n.modal--window .modal--body {\n  justify-content: flex-start;\n  padding: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
